import { Loader2 } from "lucide-react";

export default function VideoLoading() {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-gray-900/80 backdrop-blur-sm">
      {/* Optionally, use a blurred background image here */}
      <div className="flex flex-col items-center gap-6">
        <div className="flex flex-col items-center gap-2">
          <span className="rounded-lg bg-black/60 px-4 py-2 text-lg font-semibold text-white shadow-lg">
            Sales Mentoring Session
          </span>
          <span className="text-sm text-white/80">Connecting...</span>
        </div>
        <Loader2 className="size-10 animate-spin text-white/80" />
      </div>
    </div>
  );
}
